import React from 'react';

import MyRoutes from './routes';

function App() {
    return (
        <React.Fragment>
           <MyRoutes />
        </React.Fragment>
    );
}

export default App;
